import { defineAsyncComponent } from 'vue';

const SummaryInitialAggregateRegularDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryEstimateInitial/summaryInitialAggregate/SummaryInitialAggregateRegularDetail.vue'),
);

const SummaryInitialAggregateProjectDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryEstimateInitial/summaryInitialAggregate/SummaryInitialAggregateProjectDetail.vue'),
);

const SummaryInitialAggregateBaseDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryEstimateInitial/summaryInitialAggregate/SummaryInitialAggregateBaseDetail.vue'),
);

const SummaryInitialExplanationSalaryDetailPopup = defineAsyncComponent(() =>
  import('@/views/summaryAudit/summaryAuditInitial/SummaryInitialExplanationSalaryDetailPopup.vue'),
);
const SummaryEISectorWideExplanationDetailPopup = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryEISectorWide/popup/SummaryEISectorWideExplanationDetailPopup.vue'),
);

export function registerSummaryEstimateInitialAggregate(app) {
  app.component('SummaryInitialAggregateRegularDetail', SummaryInitialAggregateRegularDetail);
  app.component('SummaryInitialAggregateProjectDetail', SummaryInitialAggregateProjectDetail);
  app.component('SummaryInitialAggregateBaseDetail', SummaryInitialAggregateBaseDetail);
  app.component('SummaryEISectorWideExplanationDetailPopup', SummaryEISectorWideExplanationDetailPopup); 
  app.component('SummaryInitialExplanationSalaryDetailPopup', SummaryInitialExplanationSalaryDetailPopup);

}
